import React from "react";
import logo from "../Nav/img/Logo.jpg";
import {Columns, Table} from "react-bulma-components";
import PrintPartList from "./PrintPartList";



class PrintQuote extends React.Component {

    PartRow(part){
        return (
            <tr>
                <td>{part.name}</td>
                <td>{part.part_number}</td>
                <td>{part.supplier ? part.supplier.display_name : ""}</td>
                <td>£{(Math.round(part.customer_cost * 100 +Number.EPSILON) / 100) ?? 0}</td>
            </tr>
        )
    }


    render() {
        const partOrder = this.props.data;
        const parts = partOrder.parts;
        let totalCustomerCost = partOrder.total_part_customer_charge;
        let totalCustomerCostVat = partOrder.total_part_customer_charge_inc_vat

        // if(parts.length > 0){
        //     parts.forEach(part => {
        //         totalCustomerCost += part.customer_cost
        //     })
        // }

        return (
            <div>
                <Columns>
                  <img src={logo} style={{width: '110px', height: '35px'}} alt="Rentals Direct Ltd" />
                  <h2 className="job-card-print-title">{`Part Order - ${partOrder ? partOrder.id : ""}`}</h2>
                </Columns>
                <br/>
                <Columns className={"page-break"}>
                    <Columns.Column>
                        <div>
                            <Table bordered>
                                <thead>
                                  <tr>
                                    <th>Customer</th>
                                    <th>Customer Vehicle</th>
                                    <th>Customer Order Number</th>
                                    <th>Total Customer Cost</th>
                                    <th>Total Customer Cost (Inc VAT)</th>
                                  </tr>
                                </thead>
                                <tr>
                                  <td data-testid={"customer"}>{partOrder.customer ? partOrder.customer.display_name : ""}</td>
                                  <td data-testid={"customer-vehicle"}>{partOrder.customer_vehicle}</td>
                                  <td data-testid={"order-number"}>{partOrder.order_number}</td>
                                  <td data-testid={"total-customer-cost"}>{`£${totalCustomerCost}`}</td>
                                  <td data-testid={"total-customer-cost-vat"}>{`£${totalCustomerCostVat}`}</td>
                                </tr>
                            </Table>
                            <Table
                                bordered
                            >
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Part Number</th>
                                        <th>Part Supplier</th>
                                        <th>Customer Charge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parts.map(part => this.PartRow(part))}
                                </tbody>
                            </Table>
                        </div>
                    </Columns.Column>
                </Columns>
            </div>
        )
    }

}
export default PrintQuote